// Needed for scripts that expect jQuery to be globally available
import $ from "jquery";
window.$ = $;
window.jQuery = $;
